// 创建担保
const createGuarantee = () => import('../views/applyGuarantee/createGuarantee')
// 担保基本信息
const guaranteeInfo = () => import('../views/applyGuarantee/guaranteeInfo.vue')
// 担保申请变更基本信息
const guaranteeSQBGInfo = () => import('../views/applyGuarantee/guarantee-info/index.vue')
// 担保详情
const guaranteeDetail = () => import('../views/applyGuarantee/guaranteeDetail')
// 添加申请人
const addSQR = () => import('../views/applyGuarantee/addGuarantee/addSQR')
// 添加被申请人
const addBSQR = () => import('../views/applyGuarantee/addGuarantee/addBSQR')
// 添加原告代理人
const addYGDLR = () => import('../views/applyGuarantee/addGuarantee/addYGDLR')
// 添加原告代理人
const getSsygList = () => import('../views/applyGuarantee/addGuarantee/getSsygList')
// 添加财产线索
const addCCXS = () => import('../views/applyGuarantee/addGuarantee/addCCXS')
// 担保评价
const guaranteeRate = () => import('../views/applyGuarantee/guaranteeRate')
// 查看担保评价
const guaranteeRate_CK = () => import('../views/applyGuarantee/guaranteeRate_CK')
// 补充担保
const previewBCDB = () => import('../views/applyGuarantee/supplementGuarantee/preview-BCDB/index.vue')
// 平安交费页面
const wxpay = () => import('../views/applyGuarantee/previewGuarantee/previewWxpay')
// 一键申请保全
const guaranteeOnKey = () => import('../views/applyGuarantee/guarantee-one-key/index.vue');
// 添加担保机构
const addDBJG = () => import('../views/applyGuarantee/addGuarantee/addDBJG')

export default [
    {
        path: '/kaiPiaoEdit',
        name: 'kaiPiaoEdit',
        component: () => import('../views/applyGuarantee/kaiPiao/kpEdit'),
        meta: {
            title: '担保服务-填写开票信息'
        }
    },
    {
        path: '/kaiPiaoInfo',
        name: 'kaiPiaoInfo',
        component: () => import('../views/applyGuarantee/kaiPiao/kpInfo'),
        meta: {
            title: '担保服务-申请开票信息'
        }
    },

    {
        path: '/tuiBaoEdit',
        name: 'tuiBaoEdit',
        component: () => import('../views/applyGuarantee/tuiBao/tbEdit'),
        meta: {
            title: '担保服务-填写退保信息'
        }
    },
    {
        path: '/tuiBaoInfo',
        name: 'tuiBaoInfo',
        component: () => import('../views/applyGuarantee/tuiBao/tbInfo'),
        meta: {
            title: '担保服务-退保信息'
        }
    },

    {
        path: '/createGuarantee',
        name: 'createGuarantee',
        component: createGuarantee,
        meta: {
            title: '担保服务-申请担保',
            keepAlive: true // 需要被缓存
        },
    },
    {
        path: '/guaranteeInfo',
        name: 'guaranteeInfo',
        component: guaranteeInfo,
        meta: {
            title: '担保服务-担保信息',
            keepAlive: true // 需要被缓存
        },
    },
    {
        path: '/guarantee-sqbg-info',
        name: 'guaranteeSQBGInfo',
        component: guaranteeSQBGInfo,
        meta: {
            title: '担保服务-变更担保信息'
        },
    },
    {
        path: '/guaranteeDetail',
        name: 'guaranteeDetail',
        component: guaranteeDetail,
        meta: {
            title: '担保服务-担保详情',
        },
    },
    {
        path: '/addSQR',
        name: 'addSQR',
        component: addSQR,
        meta: {
            title: '担保服务-申请人'
        }
    },
    {
        path: '/addBSQR',
        name: 'addBSQR',
        component: addBSQR,
        meta: {
            title: '担保服务-被申请人'
        }
    },
    {
        path: '/addYGDLR',
        name: 'addYGDLR',
        component: addYGDLR,
        meta: {
            title: '担保服务-原告代理人',
        }
    },
    {
        path: '/getSsygList',
        name: 'getSsygList',
        component: getSsygList,
        meta: {
            title: '担保服务-所属原告',
            // keepAlive: true // 需要被缓存
        }
    },
    {
        path: '/addCCXS',
        name: 'addCCXS',
        component: addCCXS,
        meta: {
            title: '担保服务-财产线索'
        }
    },
    {
        path: '/guaranteeRate',
        name: 'guaranteeRate',
        component: guaranteeRate,
        meta: {
            title: '担保服务-担保评价'
        }
    },
    {
        path: '/guaranteeRate_CK',
        name: 'guaranteeRate_CK',
        component: guaranteeRate_CK,
        meta: {
            title: '担保服务-查看担保评价'
        }
    },
    {
        path: '/previewBCDB',
        name: 'previewBCDB',
        component: previewBCDB,
        meta: {
            title: '担保服务-补充担保'
        }
    },
    {
        path:'/wxpay',
        name: 'wxpay',
        component: wxpay,
        meta: {
            title: '担保服务-平安交费'
        }
    },
    {
        path:'/guarantee-one-key',
        name: 'guaranteeOneKey',
        component: guaranteeOnKey,
        meta: {
            title: '担保服务-申请保全信息'
        }
    },
    {
        path: '/addDBJG',
        name: 'addDBJG',
        component: addDBJG,
        meta: {
            title: '担保服务-担保机构'
        }
    }
]
